export const ISOFilesApi = [
    {
      id: 1,
      Name: "Windows 11",
      Image: "images/win_11.jpg",
      link: 'https://getintopc.com/softwares/operating-systems/windows-11-pro-january-2022-free-download-3964990/',
      FullName: "Windos 11 Pro June 2022 Setup",
      size: "4.9",
      Compatibility: "64-bit only",
      Developers: "Microsoft Corporation",
      RAM: "4",
      HardDisk: "64",
      Graphicscard: "DirectX 12 compatible graphics / WDDM 2.x",
      Processor: "1 GHz more cores on a compatible 64-bit processor",
    },
    {
      id: 2,
      Name: " Windows 11 Lite",
      Image: "images/win11lite.jfif",
        link: 'https://drive.google.com/uc?export=download&id=15UvhSy0U7dl3FNpBX5s1-LdBuDBhd_s1',
      FullName: "Windows 11 Lite 2021",
      size: "1.2",
      Compatibility: "64-bit only",
      Developers: "Unofficial (Keral) ",
      RAM: "0.25",
      HardDisk: "5",
      Graphicscard: "N/A",
      Processor: "1 GHz dual-core processor or better",
    },
    {
        id: 3,
        Name: "Windos 10 Pro May 2022",
        Image: "images/win_10.jpg",
          link: 'https://getintopc.com/softwares/operating-systems/windows-10-pro-x64-redstone-5-multi-language-24-iso-download-1073744/',
        FullName: "Windows 10 Pro May 2022 ",
        size: "5",
        Compatibility: "64bit (x64) or 32bit (x86)",
        Developers: "Microsoft Team",
        RAM: "1.2",
        HardDisk: "10",
        Graphicscard: "N/A",
        Processor: "Intel Dual Core Processor",
      },
      {
        id: 4,
        Name: "Windos 10 Lite",
        Image: "images/win10lite.jpg",
          link: 'https://mega.nz/file/z08UGBLI#DY8SBrpKScnuHULKOCROILUG5syFuZ-ZVymnVXJQf6g',
        FullName: "Tiny windows 10 (Lite)",
        size: "1.2",
        Compatibility: "32bit (x84) or 64bit (x64)",
        Developers: "Unofficial",
        RAM: "0.80",
        HardDisk: "10",
        Graphicscard: " N/A",
        Processor: "Core2Duo (1GHz)",
      },
      {
        id: 5,
        Name: "Windows 7",
        Image: "images/win_7.jpg",
          link: '"https://www.mediafire.com/file/5yixjpa1q9oqhiu/Win07_Ultimate_x64.iso/file',
        FullName: " Windows 7 SP1 March 2019",
        size: "2.8",
        Compatibility: "64bit (x64)",
        Developers: "Unofficial",
        RAM: "2",
        HardDisk: "16",
        Graphicscard: " N/A",
        Processor: "Core2Duo (1GHz)",
      },

  ];
  